import React, {
  Component
} from 'react';
import {
  hashHistory
} from 'react-router';
/*弹出框*/
export class AnswerAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  handdleClose(){
    this.props.Close()
  }
  render() {
    let width = window.screen.width;
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={()=>{this.touchmove }} onTouchstart={()=> { return false; }} >
          <div style={{ width:width, position:"relative",}}>
            <div className="ruleImgWrap">
              <div style={{ width:width-11}}>
                <img
                  src={this.props.url}
                  style={{ width:width-11}}
                />

                <div className="closeRuleWrap" style={{width:width }}>
                  <div className="closeRule" onClick={()=>{ this.handdleClose() }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export class AlerModleTips extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
     <div style={{ width:"300px", background:"#FFF", borderRadius:"10px", position:"relative" }}>
       
            <div>
      
              <div className="alertContent">
                { this.props.content }
              </div>
              <div className="alertSureBtn" onClick={ ()=>{ this.props.handleSure() } }>
                确认
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export class AlertError extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
     <div style={{ width:"300px", background:"#FFF", borderRadius:"10px", position:"relative" }}>
       
            <div>
      
              <div className="AlertErrorContent" style={{height:180}}>
                { this.props.content }
              </div>
              <div className="alertSureBtn" onClick={ ()=>{ this.props.handleSure() } }>
                确认
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export class AlertResule extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount() {
    document.getElementsByTagName('html')[0].style.overflowY='hidden';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
  }
  componentWillUnmount(){
    document.getElementsByTagName('html')[0].style.overflowY='auto';
    document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"")
  }
  goBack() {
    hashHistory.goBack();
    // this.props.history.push({
    //     pathname:'/',
    // })
  }
  touchmove(event){
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  }
  render() {
    // let data = this.props.location.state.data ? this.props.location.state.data : [];
    return (
      <div className="AlerModle_DIV" onClick={(event)=>{ event.stopPropagation(); return false }} onTouchmove={this.touchmove.bind(this)} onTouchstart={()=> { return false; }} >
     <div style={{ width:"300px", background:"#FFF", borderRadius:"10px", position:"relative" }}>
       
            <div>
      
              <div className="AlertErrorContent" style={{height:280}}>
                { this.props.content }
              </div>
            </div>
          </div>
        </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/AnswerAlert.js